import {AfterViewInit, Component, OnInit} from '@angular/core';
import {EChartOption} from 'echarts';
import {echartStyles} from '../../../shared/echart-styles';
import {TranslateService} from '@ngx-translate/core';
import {SessionStorageService} from '../../../shared/services/session-storage.service';
import {RequestService} from '../../../shared/services/request.service';

@Component({
    selector: 'app-dashboad-default',
    templateUrl: './dashboad-default.component.html',
    styleUrls: ['./dashboad-default.component.css']
})
export class DashboadDefaultComponent implements OnInit, AfterViewInit {
    data: any;
    salesChartBar: EChartOption;
    salesInMonth: any;
    salesInWeek: any;
    thirtyPSP: any;
    thirtyPSP1: any;
    orderSummary: any;
    private readonly defaultLanguage = 'en';

    constructor(private sessionStorageService: SessionStorageService, private translate: TranslateService, private requestService: RequestService) {
        this.defaultLanguage = sessionStorageService.getLanguageSession();
    }

    ngOnInit() {
        this.requestService.postData('api/dashboard', {}, 'post').subscribe((receivedData: Object) => {
            this.data = {
                first_block: receivedData['data']['first_block'],
                second_block: {
                    min: 0,
                    max: 100000,
                    interval: 25000,
                    walk_in_user_orders: [35000, 69000, 22500, 60000, 50000, 50000, 30000, 80000, 70000, 60000, 20000, 30005],
                    registered_user_orders: [45000, 82000, 35000, 93000, 71000, 89000, 49000, 91000, 80200, 86000, 35000, 40050]
                },
                third_block: {
                    order_summary: receivedData['data']['third_block']
                },
                fourth_block: receivedData['data']['fourth_block'],
                /*fourth_block: {
                    last_month_sale: '$40850',
                    last_month_sale_data: [30, 40, 20, 50, 40, 80, 90],
                    last_week_sale: '$10100',
                    last_week_sale_data: [10, 40, 20, 90, 30, 10, 40]
                },*/
                fifth_block: {},
                sixth_block: receivedData['data']['sixth_block']
                /*sixth_block: {
                    packages: [40, 30, 50, 90, 30, 80, 40, 30, 45, 50, 110, 90, 90, 20, 80, 145, 120, 135, 120, 140, 115, 50, 110, 90, 90, 20, 70, 30, 20, 50],
                    services: [90, 140, 40, 30, 50, 90, 30, 80, 10, 20, 80, 20, 90, 30, 50, 110, 45, 80, 40, 120, 135, 120, 110, 30, 45, 50, 110, 30, 20, 90],
                    products: [10, 20, 80, 20, 90, 120, 140, 40, 60, 40, 30, 50, 110, 90, 145, 120, 135, 80, 30, 45, 45, 50, 70, 30, 20, 70, 110, 90, 90, 20]
                }*/
            };

            this.salesInMonth = {
                ...echartStyles.defaultOptions, ...{
                    grid: echartStyles.gridAlignLeft,
                    series: [{
                        data: this.data.fourth_block.last_month_sale_data,
                        ...echartStyles.smoothLine,
                        lineStyle: {
                            color: '#4CAF50',
                            ...echartStyles.lineShadow
                        },
                        itemStyle: {
                            color: '#4CAF50'
                        }
                    }]
                }
            };
            this.salesInMonth.grid = {show: false, top: 6, right: 0, left: 0, bottom: 20};
            this.salesInMonth.xAxis = {data: ['1st week', '2nd week', '3rd week', '4th week']};

            this.salesInWeek = {
                ...echartStyles.defaultOptions, ...{
                    grid: echartStyles.gridAlignLeft,
                    series: [{
                        data: this.data.fourth_block.last_week_sale_data,
                        ...echartStyles.smoothLine,
                        lineStyle: {
                            color: '#4CAF50',
                            ...echartStyles.lineShadow
                        },
                        itemStyle: {
                            color: '#4CAF50'
                        }
                    }]
                }
            };
            this.salesInWeek.grid = {show: false, top: 6, right: 0, left: 0, bottom: 20};

            this.thirtyPSP = {
                ...echartStyles.lineFullWidth, ...{
                    series: [
                        {
                            name: 'Packages',
                            data: this.data.sixth_block.packages,
                            ...echartStyles.smoothLine,
                            markArea: {
                                label: {
                                    show: true
                                }
                            },
                            areaStyle: {
                                color: 'rgba(102, 51, 153, 0.1)',
                                origin: 'start'
                            },
                            lineStyle: {
                                // width: 1,
                                color: 'rgba(102, 51, 153, 0.68)',
                            },
                            itemStyle: {
                                color: '#663399'
                            }
                        },
                        {
                            name: 'Services',
                            data: this.data.sixth_block.services,
                            ...echartStyles.smoothLine,
                            markArea: {
                                label: {
                                    show: true
                                }
                            },
                            areaStyle: {
                                color: 'rgba(255, 152, 0, 0.1)',
                                origin: 'start'
                            },
                            lineStyle: {
                                // width: 1,
                                color: 'rgba(255, 152, 0, 0.6)',
                            },
                            itemStyle: {
                                color: 'rgba(255, 152, 0, 1)'
                            }
                        },
                        {
                            name: 'Products',
                            data: this.data.sixth_block.products,
                            ...echartStyles.smoothLine,
                            markArea: {
                                label: {
                                    show: true
                                }
                            },
                            areaStyle: {
                                color: 'rgba(76, 175, 80, 0.1)',
                                origin: 'start'
                            },
                            lineStyle: {
                                // width: 1,
                                color: 'rgba(76, 175, 80, 0.6)',
                            },
                            itemStyle: {
                                color: '#4CAF50'
                            }
                        }
                    ]
                },
                xAxis: {
                    data: Array.from({length: 30}, (v: number, k: number) => k + 1)
                },
                label: {show: true, color: '#212121'},
            };

            this.thirtyPSP.grid = {show: false, top: 6, right: 0, left: 0, bottom: 40};

            this.salesChartBar = {
                legend: {
                    borderRadius: 0,
                    orient: 'horizontal',
                    x: 'right',
                    data: ['Walk-In user order', 'Registered user order']
                },
                grid: {
                    left: '8px',
                    right: '8px',
                    bottom: '0',
                    containLabel: true
                },
                tooltip: {
                    show: true,
                    backgroundColor: 'rgba(0, 0, 0, .8)'
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
                        axisTick: {
                            alignWithLabel: true
                        },
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '${value}'
                        },
                        min: this.data.second_block.min,
                        max: this.data.second_block.max,
                        interval: this.data.second_block.interval,
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            interval: 'auto'
                        }
                    }
                ],
                series: [
                    {
                        name: 'Walk-In user order',
                        data: this.data.second_block.walk_in_user_orders,
                        label: {show: false, color: '#ee9403'},
                        type: 'bar',
                        barGap: 0,
                        color: '#ee9403',
                        smooth: true,
                    },
                    {
                        name: 'Registered user order',
                        data: this.data.second_block.registered_user_orders,
                        label: {show: false, color: '#639'},
                        type: 'bar',
                        color: '#0c0c3c',
                        smooth: true
                    }
                ]
            };

            this.thirtyPSP1 = {
                legend: {
                    borderRadius: 0,
                    orient: 'horizontal',
                    x: 'right',
                    data: ['Packages', 'Services', 'Products']
                },
                grid: {
                    left: '8px',
                    right: '8px',
                    bottom: '0',
                    containLabel: true
                },
                tooltip: {
                    show: true,
                    backgroundColor: 'rgba(0, 0, 0, .8)'
                },
                xAxis: [
                    {
                        type: 'category',
                        data: Array.from({length: 31}, (v: number, k: number) => k + 1),
                        axisTick: {
                            alignWithLabel: true
                        },
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        },
                        // min: 0,
                        // max: 500,
                        // interval: 10,
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            interval: 'auto'
                        }
                    }
                ],
                series: [
                    {
                        name: 'Packages',
                        data: this.data.sixth_block.packages,
                        label: {show: false, color: '#639'},
                        type: 'bar',
                        barGap: 0,
                        color: '#0c0c3c',
                        smooth: true,
                    },
                    {
                        name: 'Services',
                        data: this.data.sixth_block.services,
                        label: {show: false, color: '#ee9403'},
                        type: 'bar',
                        color: '#ee9403',
                        smooth: true
                    },
                    {
                        name: 'Products',
                        data: this.data.sixth_block.products,
                        label: {show: false, color: '#376e37'},
                        type: 'bar',
                        color: '#4CAF50',
                        smooth: true
                    }
                ]
            };

            this.orderSummary = {
                ...echartStyles.defaultOptions, ...{
                    legend: {
                        show: true,
                        bottom: 0,
                    },
                    series: [{
                        type: 'pie',
                        ...echartStyles.pieRing,

                        label: echartStyles.pieLabelCenterHover,
                        data: [
                            {
                                name: 'Completed',
                                value: this.data.third_block.order_summary.completed,
                                itemStyle: {
                                    color: '#4CAF50',
                                }
                            },
                            {
                                name: 'Working',
                                value: this.data.third_block.order_summary.working,
                                itemStyle: {
                                    color: '#ee9403',
                                }
                            },
                            {
                                name: 'Pending',
                                value: this.data.third_block.order_summary.pending,
                                itemStyle: {
                                    color: '#ced4da',
                                }
                            }
                        ]
                    }]
                }
            };
        });
    }

    ngAfterViewInit(): void {
        const languageToUse = this.defaultLanguage == null ? 'en' : this.defaultLanguage;
        this.translate.use('/' + languageToUse);
    }

    isUndefined(variable: any) {
        return variable == undefined ? 0 : variable;
    }

}
